import styled from 'styled-components';

export const List = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
`;
